import { Link } from 'react-router-dom';

const newsItems = [
  {
    id: 1,
    text: "Start your FREE 7-day trial of AMS Compass — Stop guessing, start profiting!",
    link: "https://www.madeartisanmarkets.com",
    isExternal: true
  },
  {
    id: 2,
    text: "Call for Vendors: Festival of Trees 2026 — Vendor spots filling fast!",
    link: "/events/festival-of-trees",
    isExternal: false
  },
  {
    id: 3,
    text: "Book an Artisan Market for your next event — Turnkey solution for any venue!",
    link: "/events",
    isExternal: false
  }
];

export function NewsTicker() {
  // Duplicate items for seamless loop
  const duplicatedItems = [...newsItems, ...newsItems, ...newsItems];

  return (
    <div 
      className="bg-[#0F4C3A] text-white py-2.5 overflow-hidden relative"
      data-testid="news-ticker"
    >
      <div className="ticker-wrapper">
        <div className="ticker-content">
          {duplicatedItems.map((item, index) => (
            <span key={`${item.id}-${index}`} className="ticker-item">
              {item.isExternal ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-amber-300 transition-colors duration-200 underline-offset-2 hover:underline"
                  data-testid={`news-link-${item.id}`}
                >
                  {item.text}
                </a>
              ) : (
                <Link
                  to={item.link}
                  className="hover:text-amber-300 transition-colors duration-200 underline-offset-2 hover:underline"
                  data-testid={`news-link-${item.id}`}
                >
                  {item.text}
                </Link>
              )}
              <span className="mx-8 text-amber-400">★</span>
            </span>
          ))}
        </div>
      </div>

      <style>{`
        .ticker-wrapper {
          width: 100%;
          overflow: hidden;
        }
        
        .ticker-content {
          display: inline-flex;
          white-space: nowrap;
          animation: ticker 45s linear infinite;
        }
        
        .ticker-item {
          display: inline-flex;
          align-items: center;
          font-size: 0.9rem;
          font-weight: 500;
          letter-spacing: 0.02em;
        }
        
        @keyframes ticker {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%);
          }
        }
        
        .ticker-content:hover {
          animation-play-state: paused;
        }
        
        @media (max-width: 768px) {
          .ticker-item {
            font-size: 0.8rem;
          }
          .ticker-content {
            animation-duration: 35s;
          }
        }
      `}</style>
    </div>
  );
}
